import styled from 'styled-components';
import { colors } from 'vars';

interface StyledAlertContainerProps {
  $type: 'info' | 'confirm' | 'warning';
}

export const StyledAlertContainer = styled.div<StyledAlertContainerProps>`
  ${({ $type }) => {
    let color = colors.black;
    if ($type === 'confirm') color = colors.green01400;
    if ($type === 'warning') color = colors.orange01400;
    if ($type === 'info') color = colors.blue01700;

    return `
      display: flex;
      gap: 8px;
      width: 100%;
      padding: 16px 12px;
      border: 1px solid ${colors.grey01500};
      border-bottom: 2px solid ${color};
      border-radius: 4px;

      i.icon {
        color: ${color};
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 25.6px;
        color: ${colors.grey01300};
      }
    `;
  }}
`;
